import { httpClient } from '../http/httpClient'

export interface Occupation {
  id: string
  occupationId: string
  nome: string
  ativo: boolean
}

export interface OccupationResponse {
  items: Occupation[]
}

export async function getOccupations() {
  const { data } =
    await httpClient.get<OccupationResponse>('/crefaz/occupation')
  return data
}
